<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar"><span class="h-panel-title">资金报表</span></div>

        <div class="div_tabs">
            <a-tabs v-model:activeKey="activeKey" type="card" @click="tabClick()" >
                
                <a-tab-pane key="1" tab="按账户汇总">
                    <div class="div_tab_query">
                    时间：<a-range-picker :locale="locale" v-model="tab1Query.dp"  @change="onTimeChange" />&nbsp;
                    账号类别： <a-select   v-model:value="tab1Query.actType" style="width: 120px" allowClear >
                        <a-select-option :value="1">现金</a-select-option>
                        <a-select-option :value="2">银行</a-select-option>
                        <a-select-option :value="3">其他</a-select-option>
                        <a-select-option :value="4">微信</a-select-option>
                        <a-select-option :value="5">支付宝</a-select-option>
                        <a-select-option :value="6">在线支付</a-select-option>
                        </a-select>
                    &nbsp;
                    账号：<a-select   v-model="tab1Query.actId" style="width:200px;padding-right:5px;" :options="actSelectData" allowClear @change="loadList1" > </a-select>
                    &nbsp;
                    <button class="h-btn " @click="loadList1">查询</button> 
                     </div>

                     <div class="div_tabs_table">
                        <Table :datas="tab1Data" :height="650" :border="true">
                            <TableItem title="序号"  :width="80"><template slot-scope="{index}">{{index+1}}</template></TableItem>
                            <TableItem title="账号编码" prop="actCode" :width="100" />
                            <TableItem title="账号名称" prop="actName" align="center" :width="200" />
                            <TableItem title="账号类型"   align="center" :width="100" >
                                <template #default="{ data }"> 
                                    <span   >
                                        {{  data.actType==1?"现金":
                                            data.actType==2?"银行":
                                            data.actType==3?"其他":
                                            data.actType==4?"微信支付":
                                            data.actType==5?"支付宝":
                                            data.actType==6?"在线支付":""
                                        }}</span> 
                                </template>
                            </TableItem>
                            <TableItem title="期初余额"  align="center" :width="100" >
                                <template #default="{ data }"> 
                                    <span   >
                                        {{  numFormat(data.actBeforeAmount) }}</span> 
                                </template> 
                            </TableItem>
                            <TableItem title="收入总额"  align="center" :width="100" >
                                 <template #default="{ data }"> 
                                    <span   >
                                        {{  numFormat(data.incomeAmount) }}</span> 
                                </template> 
                            </TableItem>
                            <TableItem title="支出总额"   align="center" :width="100" >
                                 <template #default="{ data }"> 
                                    <span   >
                                        {{  numFormat(data.payAmount) }}</span> 
                                </template> 
                            </TableItem>
                            <TableItem title="期末余额"   align="center" :width="100" >
                                 <template #default="{ data }"> 
                                    <span   >
                                        {{  numFormat(data.actAfterAmount) }}</span> 
                                </template> 
                            </TableItem>
                            <template #empty>
                                自定义提醒：暂时无数据
                            </template>
                        </Table>
                     </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="按收支类型汇总"  >
                    <div class="div_tab_query">
                    时间：<a-range-picker :locale="locale" v-model="tab2Query.dp"  @change="onTimeChange2" />&nbsp;
                     
                    &nbsp;
                    <button class="h-btn " @click="loadList2">查询</button> 
                    <button style="float:right" class="h-btn " @click="$refs.tree_tb2.foldAll()">折叠</button> 
                    <button style="float:right" class="h-btn " @click="$refs.tree_tb2.expandAll()">展开</button> 
                     </div>

                     <div class="div_tabs_table">
                        <Table :datas="tab2Data" :height="650" ref="tree_tb2" :border="true"   >
                            <TableItem title="编码" prop="code"  :width="100" />
                            <TableItem title="收支类型" prop="name" :treeOpener="true" align="center"/> 
                            <TableItem title="收入总额"   align="center" >
                                <template #default="{ data }"> 
                                    <span  :style="data.code==1?'font-size:15px;color:#009393':''"  >
                                        {{ numFormat(data.incomeAmount==0?"-":data.incomeAmount) }}
                                    </span> 
                                </template>
                            </TableItem>
                            <TableItem title="支出总额"   align="center"  >
                                <template #default="{ data }"> 
                                    <span :style="data.code==2?'font-size:15px;color:#d26900':''"  >
                                        {{  numFormat(data.payAmount==0?"-":data.payAmount) }}
                                    </span> 
                                </template>
                            </TableItem> 
                             
                            <template #empty>
                                自定义提醒：暂时无数据
                            </template>
                        </Table>
                     </div>
                </a-tab-pane>
                <a-tab-pane key="3" tab="收支明细表">
                    <div class="div_tab_query">
                        时间：<a-range-picker :locale="locale" v-model="tab3Query.dp"  @change="onTimeChange3" />&nbsp;
                        账号：<a-select   v-model="tab3Query.actId" style="width:200px;padding-right:5px;" :options="actSelectData" allowClear   > </a-select>&nbsp;
                        <button class="h-btn " @click="loadList3">查询</button> 
                        <button style="float:right" class="h-btn" @click="$refs.tree_tb3.foldAll()">折叠</button> 
                        <button style="float:right" class="h-btn" @click="$refs.tree_tb3.expandAll()">展开</button> 
                    </div>
                    <div class="div_tabs_table">
                        <Table :datas="tab3Data" :height="650" ref="tree_tb3" :border="true"   >
                            <TableItem title="项目" prop="name"    :treeOpener="true" />
                            <TableItem title="本期间"   align="center" >
                                <template #default="{ data }"> 
                                    <span  :style="data.code=='#'?'font-size:15px;color:#009393':''"  >
                                        {{  numFormat(data.amount==0?"-":data.amount) }}
                                    </span> 
                                </template>
                            </TableItem>
                            <TableItem title="本年累计数"   align="center"  >
                                <template #default="{ data }"> 
                                    <span :style="data.code=='#'?'font-size:15px;color:#d26900':''"  >
                                        {{  numFormat(data.yearAmount==0?"-":data.yearAmount) }}
                                    </span> 
                                </template>
                            </TableItem> 
                            <template #empty>
                                自定义提醒：暂时无数据
                            </template>
                        </Table>
                     </div>
                </a-tab-pane>
            </a-tabs>
        </div>
	
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import 'moment/locale/zh-cn';

import moment from 'moment'
import { mapState } from 'vuex'

export default {
	name: "Salarymanage",
    watch: {  
		},
	data() {
		return {
            activeKey:"1",
			loading:false,
            locale:locale,
            actSelectData:[],
            tab1Data:[],
            tab2Data:[],
            tab3Data:[],
            tab1Query:{
                dp:[],
                startTime:undefined,
                endTime:undefined,
                actType:undefined,
                actId:undefined
            },
            tab2Query:{
                dp:[],
                startTime:undefined,
                endTime:undefined
            }, 
            tab3Query:{
                actId:undefined,
                dp:[],
                startTime:undefined,
                endTime:undefined
            }
		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
		date() {
			return moment(this.accountDate);
		}
	},
	created() {  
        this.loadActList();
		this.loadList1();
	},
	mounted() {
        
	},
	methods: {
        loadActList(){
            var accountSetsId = this.User.accountSetsId;
            this.$api.cashier.act_list(accountSetsId).then(({ data }) => { 
                if(data!=undefined && data.length>0){
                    for(var i = 0;i<data.length;i++){
                        var ops = {
                            value:data[i].id,
                            label:data[i].name
                        }
                        this.actSelectData.push(ops);
                    }  
                }
            });
        }, 
        loadList1(){
            //按账号汇总
            var accountSetsId = this.User.accountSetsId;
            if(this.tab1Query.startTime==undefined ||this.tab1Query.startTime=='' || this.tab1Query.endTime==undefined || this.tab1Query.endTime==''){
					this.tab1Query.startTime = moment().startOf("month").format("YYYY-MM-DD");
					this.tab1Query.endTime = moment().endOf("month").format("YYYY-MM-DD");
					this.tab1Query.dp = [
						this.tab1Query.startTime,
						this.tab1Query.endTime
					]; 
                    this.tab2Query.dp = [
						this.tab1Query.startTime,
						this.tab1Query.endTime
					]; 
				}
            var params ={
                accountSetsId:accountSetsId, 
                startTime : this.tab1Query.startTime ,
                endTime:this.tab1Query.endTime,
                actType:this.tab1Query.actType,
                actId:this.tab1Query.actId
            };
            this.$api.cashier.summaryAct(params).then(({ data }) => {  
                this.tab1Data=data;
                // console.log(data);
			})
        },
        loadList2(){ 
            var accountSetsId = this.User.accountSetsId;
            if(this.tab2Query.startTime==undefined ||this.tab2Query.startTime=='' || this.tab2Query.endTime==undefined || this.tab2Query.endTime==''){
					this.tab2Query.startTime = moment().startOf("month").format("YYYY-MM-DD");
					this.tab2Query.endTime = moment().endOf("month").format("YYYY-MM-DD");
					this.tab2Query.dp = [
						this.tab2Query.startTime,
						this.tab2Query.endTime
					]; 
				}
            var params ={
                accountSetsId:accountSetsId, 
                startTime : this.tab2Query.startTime ,
                endTime:this.tab2Query.endTime
            };
            this.$api.cashier.summaryTradeType(params).then(({ data }) => {  
                this.tab2Data=data; 
			})
        },
        loadList3(){ 
            var accountSetsId = this.User.accountSetsId;
            if(this.tab3Query.startTime==undefined ||this.tab3Query.startTime=='' || this.tab3Query.endTime==undefined || this.tab3Query.endTime==''){
					this.tab3Query.startTime = moment().startOf("month").format("YYYY-MM-DD");
					this.tab3Query.endTime = moment().endOf("month").format("YYYY-MM-DD");
					this.tab3Query.dp = [
						this.tab3Query.startTime,
						this.tab3Query.endTime
					]; 
				}
              
            var params ={
                accountSetsId:accountSetsId, 
                actId:this.tab3Query.actId,
                startTime : this.tab3Query.startTime ,
                endTime:this.tab3Query.endTime
            };
            this.$api.cashier.summaryTradeActType(params).then(({ data }) => {  
                this.tab3Data=data;  
			})
            
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
		//时间筛选
        onTimeChange(date, dateString){
            this.tab1Query.startTime = dateString[0];
            this.tab1Query.endTime = dateString[1]; 
            this.loadList1();
        },
		//时间筛选
        onTimeChange2(date, dateString){
            this.tab2Query.startTime = dateString[0];
            this.tab2Query.endTime = dateString[1]; 
            this.loadList2();
        },
		//时间筛选
        onTimeChange3(date, dateString){
            this.tab3Query.startTime = dateString[0];
            this.tab3Query.endTime = dateString[1]; 
            this.loadList3();
        },
        tabClick(){
            if(this.activeKey=="1" && this.tab1Data.length==0){
                this.loadList1()
            }
            if(this.activeKey=="2"&& this.tab2Data.length==0){
                this.loadList2();
            }
            if(this.activeKey=="3"&& this.tab3Data.length==0){
                if(this.actSelectData!=undefined &&  this.actSelectData.length>0){
                    if(this.tab3Query.actId==undefined){
                        this.tab3Query.actId=this.actSelectData[0].value
                    }
                    this.loadList3();
                } 
                
            } 
        },
        numFormat(num) {
        if(num==undefined){
          return 0;
        }
        if(isNaN(num)){
          return '-';
        } 
        return num.toString().indexOf ('.') !== -1? num.toLocaleString(): num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      }
		  
		  
		

	},
	mounted() {

	}
}
</script>


<style lang="less" scoped>
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}
}

.topselectbox {}

.topselectbox .topselect02 {
	padding-top: 15px;
	padding-left: 20px;
}

.tablebox {
	padding-left: 20px;
	padding-top: 20px;
}

.fiveeditbox {
	width: 800px;
	margin: 0 auto;
}

.fiveeditbox ul li {}

.fiveeditbox ul li p {
	font-size: 15px;
	padding-bottom: 5px;
	padding-top: 10px;
}
.fiveeditbox table tr td span {
	font-size: 15px; 
    line-height: 31px;
    display:inline-block;
    width:90px;
}
.fiveeditbox table tr td input {
	width:70%; 
}
.fiveeditbox table tr{
    height:70px;
}
.yemabox {
	padding-top: 50px;
	padding-bottom: 30px;
}
.yema{ text-align:center; padding-top:30px;}
.div_tabs{margin-top:10px;}
.div_tab_query{
    margin-left:25px;
}
.div_tabs_table{margin-top:15px;}
</style>
